/**
 * Which copy a save is based on.
 *
 * The server refuses a save whose `base_updated_at` is older than the copy's current stamp, so
 * that two windows of the same account cannot silently overwrite each other. That only works if
 * the stamp a window sends describes the CONTENT ITS EDITOR LOADED. The draft query is refetched
 * on focus and after mutations, so reading `updated_at` straight from it hands window B the stamp
 * of window A's latest save the moment B is focused — and B's stale content then sails through.
 *
 * So the base is pinned when the editor loads a copy, ignores every later refetch, and advances
 * only when THIS window's own save succeeds (the server's response carries the new stamp).
 */

export type SaveBase = { versionId: number | null; updatedAt: string | null };

export const EMPTY_BASE: SaveBase = { versionId: null, updatedAt: null };

/** The draft payload arrived (first load, or a refetch). Pins the base once per working copy. */
export function onDraftLoaded(base: SaveBase, versionId: number, updatedAt: string | null): SaveBase {
  if (base.versionId === versionId) return base; // a refetch of the same copy: keep what the editor loaded
  return { versionId, updatedAt };
}

/** This window's save succeeded: the copy is now what we just wrote. */
export function onSaved(versionId: number, updatedAt: string | null): SaveBase {
  return { versionId, updatedAt };
}
